// Ensure the document is ready and jQuery is loaded
(function($) {
  $(document).ready(function() {

    console.log("test 4");

    // Check if URL contains the specific query string and hash
    if (window.location.search === '?contact_posted=true' && window.location.hash === '#contact_form') {
      $('html').addClass('open-lightbox');
    }

    $('.aw-show-lighbox').click(function () {
      $('html').toggleClass('open-lightbox');
    });

    $('button[data-lightbox-item="1"]').click(function () {
      $('html').addClass('show-all-field');
    });

    $('.aw-close-lightbox').click(function () {
      $('html').removeClass('open-lightbox');
      $('html').removeClass('show-all-field');

      // Remove the query string and hash from the URL
      if (window.location.search === '?contact_posted=true' && window.location.hash === '#contact_form') {
        let cleanURL = window.location.href.split('?')[0];
        window.history.replaceState({}, document.title, cleanURL);

        // Force the page to reload
        window.location.reload();
      }
    });

    // Initialize Flickity carousel
    var $heroSlider = $('.hero-carousel').flickity({
      freeScroll: false,
      imagesLoaded: true,
      wrapAround: true,
      cellAlign: 'left',
      cellSelector: '.carousel-cell',
      groupCells: 1,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      lazyLoad: true,
      autoPlay: 6000,
      pauseAutoPlayOnHover: false
    });

    $heroSlider.show().flickity('resize');
    $('.frontpage-about .content-block').addClass('is-in-view');

    // Make sure this runs after initFlickitySlider()
    // var $heroSlider = $('.hero-carousel:not([data-flickity-slider])').flickity({
    //   freeScroll: false,
    //   imagesLoaded: true,
    //   wrapAround: true,
    //   cellAlign: 'left',
    //   cellSelector: '.carousel-cell',
    //   groupCells: 1,
    //   contain: true,
    //   pageDots: false,
    //   prevNextButtons: false,
    //   lazyLoad: true,
    //   autoPlay: 5000,
    //   pauseAutoPlayOnHover: true
    // });

    // $heroSlider.show().flickity('resize');

  });
})(jQuery); 
